import { WebsiteElement } from '@/interfaces/element.interface';
import { ApiQueryParams, apiRequest } from '../Api';

export interface UpdateWebsiteElementResponse {
  success: boolean;
  message: string;
  data: { id: string };
  execution_time: number;
  cached: boolean;
  timestamp: string;
}

export const updateWebsiteElement = (
  elementId: string,
  params: ApiQueryParams,
  data: Partial<WebsiteElement>
) =>
  apiRequest<Partial<WebsiteElement>, UpdateWebsiteElementResponse>({
    url: `/entities/update/${elementId}`,
    scope: 'element',
    method: 'PUT',
    params,
    data: { data },
  });